class PhoneField extends HTMLElement {
  constructor() {
    super()

    this.getInputFields.forEach(input => {
      input.addEventListener('keydown', this.enforceFormat.bind(this))
      input.addEventListener('keyup', this.formatToPhone.bind(this))
    })
  }

  isNumericInput (event) {
    const key = event.key
    return (key >= 0 && key < 10)
  }

  isModifierKey (event) {
    const key = event.key
    const allowedKeys = ['Backspace', 'Tab', 'Enter', 'Delete', 'ArrowLeft', 'ArrowUp', 'ArrowRight', 'ArrowDown']
    const metaKeys = ['a', 'c', 'v', 'x', 'z']

    return (event.shiftKey === true || key === 'Home' || key === 'End') ||
      (allowedKeys.indexOf(key) !== -1) ||
      (
        (event.ctrlKey === true || event.metaKey === true) &&
        (metaKeys.indexOf(key) !== -1)
      )
  }

  enforceFormat (event) {
    if (!this.isNumericInput(event) && !this.isModifierKey(event)) event.preventDefault()
  }

  formatToPhone (event) {
    if (this.isModifierKey(event)) return false
    const input = event.target.value.replace(/\D/g,'').substring(0, 10)
    const areaCode = input.substring(0, 3)
    const middle = input.substring(3, 6)
    const last = input.substring(6, 10)

    if (input.length > 6) event.target.value = `${areaCode}-${middle}-${last}`
    else if (input.length > 3) event.target.value = `${areaCode}-${middle}`
    else if (input.length > 0) event.target.value = `${areaCode}`
  }

  get getInputFields () {
    return this.querySelectorAll('input')
  }
}

window.customElements.define('hh-phone-field', PhoneField)
